export var originalHREF = {helloSignOAuth: false, access_token: ""};
//ORIGINAL_HREF.originalHREF['access_token'] === undefined